import { useCallback, useEffect, useState } from "react";
import { RefreshCw } from "lucide-react";
import api from "../../lib/api";

export default function Captcha({ onChange }) {
  const [cap, setCap] = useState(null);
  const [answer, setAnswer] = useState("");

  const load = useCallback(async () => {
    setAnswer("");
    onChange({ captcha_id: "", answer: "" });
    try {
      const r = await api.get("/auth/captcha");
      setCap(r.data);
      onChange({ captcha_id: r.data.captcha_id, answer: "" });
    } catch (e) { /* ignore */ }
  }, []); // eslint-disable-line

  useEffect(() => { load(); }, [load]);

  return (
    <div data-testid="captcha-field">
      <label htmlFor="captcha-answer" className="mb-1.5 block text-xs font-bold uppercase tracking-wider text-slate-500">
        CAPTCHA <span className="text-red-500">*</span>
      </label>
      <div className="flex items-center gap-3">
        {cap
          ? <img src={cap.svg} alt="CAPTCHA question" className="h-[54px] w-[180px] shrink-0 rounded-lg" data-testid="captcha-image" />
          : <span className="h-[54px] w-[180px] shrink-0 animate-pulse rounded-lg bg-slate-100" />}
        <button type="button" onClick={load} aria-label="New CAPTCHA" data-testid="captcha-refresh"
          className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-gray-200 text-navy transition-colors hover:border-saffron-500">
          <RefreshCw size={15} />
        </button>
        <input id="captcha-answer" data-testid="captcha-answer" value={answer} required inputMode="numeric"
          onChange={(e) => { setAnswer(e.target.value); onChange({ captcha_id: cap?.captcha_id || "", answer: e.target.value }); }}
          placeholder="Answer" autoComplete="off"
          className="w-full rounded-md border border-gray-200 px-4 py-2.5 text-sm outline-none focus:ring-2 focus:ring-saffron-500/50" />
      </div>
    </div>
  );
}
